import Text from '../text'

export type ErrorProps = {
  errorMessage?: string | null
}

export const Error = ({ errorMessage }: ErrorProps) => {
  if (!errorMessage) return null

  return (
    <Text
      role="alert"
      aria-label={errorMessage}
      className="tw-mt-1 tw-text-xs tw-text-rose-600"
    >
      {errorMessage}
    </Text>
  )
}
